

export const AdnValidationQuestion=[
   
    { required: true, message:'Field is required' }, 
    {pattern:/^[a-zA-Z ]/, message:'Question must have only letters'},
    {max:100, message:'Question must have maximum of 100 characteres'},
    {min:2, message:'Question must have minimum of 2 letters'},
];